import { useMutation, useQuery } from 'react-query';
import {
  getChildList,
  getTellStoryDetail,
  getTellStoryLanguagesFn,
  getTellStoryStories,
  getTellStoryTopics,
  getTellStoryVoiceToText,
  submitTellStory,
} from './services';

import { childListResponse } from '../child/types';
import {
  ITellStoryDetailReq,
  ITellStoryStoriesReq,
  ITellStorySubmitReq,
  ITellStoryTopicsReq,
  ITellStoryVoiceToTextReq,
} from './type';

export const useTellStoryLanguage = () => {
  return useQuery({
    queryKey: ['tell-story-languages'],
    queryFn: getTellStoryLanguagesFn,
  });
};

export const useChildrenList = () => {
  return useMutation<{
    data: childListResponse[];
  }>({
    mutationKey: ['children-list'],
    mutationFn: getChildList,
  });
};

export const useTellStoryTopics = () => {
  return useMutation({
    mutationKey: ['tell-story-topics'],
    mutationFn: (data: ITellStoryTopicsReq) => getTellStoryTopics(data),
  });
};

export const useTellStoryStories = () => {
  return useMutation({
    mutationKey: ['tell-story-stories'],
    mutationFn: (data: ITellStoryStoriesReq) => getTellStoryStories(data),
  });
};

export const useTellStoryDetail = () => {
  return useMutation({
    mutationFn: (data: ITellStoryDetailReq) => getTellStoryDetail(data),
    mutationKey: ['tell-story-detail'],
  });
};

export const useTellStoryVoiceToText = () => {
  return useMutation({
    mutationFn: (data: ITellStoryVoiceToTextReq) =>
      getTellStoryVoiceToText(data),
    mutationKey: ['voice-to-text'],
  });
};

export const useSubmitTellStory = () => {
  return useMutation({
    mutationFn: (data: ITellStorySubmitReq) => submitTellStory(data),
    mutationKey: ['tell-story'],
  });
};
